var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreakCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#730BDB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4139 11.6912C24.1362 10.001 22.8548 9.11449 22.8008 9.07757L22.6154 8.95062V11.7926C22.6154 12.207 22.271 12.543 21.8462 12.543C21.4213 12.543 21.0769 12.207 21.0769 11.7926V10.5921C21.0769 7.24719 18.9184 5.13209 18.3698 4.55614C18.3698 4.55614 17.5721 3.77807 17.1733 3.38904C16.7745 3 16.3756 3 16.3756 3L16.4096 4.1295C16.384 6.02411 14.5907 8.8031 11.3598 11.9545C8.99697 14.2592 7.9922 16.4479 8.00005 19.2728C8.00733 21.8795 9.07748 24.3356 11.0135 26.1887C12.9114 28.0053 15.3873 29 18.0018 29C18.0559 29 18.1103 28.9996 18.1644 28.9988C20.801 28.9572 23.2729 27.9243 25.1249 26.0902C26.979 24.254 28 21.8233 28 19.2458C28 16.5415 27.1057 13.9291 25.4139 11.6912Z",
    fill: "url(#paint0_linear_434_1701)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_434_1701",
    x1: 19.5815,
    y1: 29,
    x2: 16.4929,
    y2: 2.99116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2E00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreakCalendar);
export default __webpack_public_path__ + "static/media/streak-calendar.17c2b251ef921c6299777d296c56dc0b.svg";
export { ForwardRef as ReactComponent };